import { render, staticRenderFns } from "./RadioSrcCubeSw.vue?vue&type=template&id=6bc847d4&"
import script from "./RadioSrcCubeSw.vue?vue&type=script&lang=js&"
export * from "./RadioSrcCubeSw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports